// import {helpers} from '@/ft-vue-core'
import moment from 'moment'

// const {setGlobalValue} = helpers
/**
 * TODO: Clean these up.  There's too much going on here
 */
export default {
  watch: {
    selectedDate (newVal, oldVal) {
      if (newVal === oldVal) return
      if (this.selectedReservationType.code === 'WALK_IN' && this.itemData.date) {
        const clubMoment = this.$ftAPI().clubMoment()
        const reservationMoment = moment(this.itemData.date)
        if (!clubMoment.isSame(reservationMoment, 'day')) {
          this.reservationType = this.reservationTypes.find(rt => rt.code === 'DINING')
          if (this.reservationType) {
            this.reservationType.onSelect()
          }
        }
      }
      this.clearPathErrors(this.jsonPath, 'date')
      this.loadSeatingTimes()
    },
    selectedLocationId (newVal, oldVal) {
      if (newVal === oldVal) return

      if (!this.forEvent) {
        // Meal period
        if (newVal && !this.getSelectedSeatingTime()) {
          // No seating time selected.  Allow max party size based on location
          const selectedLocation = this.locations.find(location => location.id === newVal)
          if (selectedLocation) {
            this.maxPartySize = selectedLocation.maxPartySizeStaff
          } else {
            console.warn('Unable to find location id', newVal, this.locations)
          }
        }
      }

      this.clearPathErrors(this.jsonPath, 'locationId')
      this.loadSeatingTimes()
    },
    seatingTimes (val) {
      if (val && val.length === 1 && this.firstValidSeatingTime && !this.itemData.time) {
        // No time has been selected, and we only have one to choose from.  Use it.
        this.selectedSeatingTime = this.firstValidSeatingTime
      }
      this.walkInTimeSelect()
    },
    selectedEventId () {
      // Event ID changed
      this.setDefaultNotificationMode(this.itemData)
      const selectedEvent = this.selectedEvent
      if (selectedEvent) {
        // Set reservation date to event date
        // this.itemData.locationId = null
        this.itemData.date = selectedEvent.date
        // Load questions
        if (selectedEvent.costs && selectedEvent.costs.length === 1 && this.isNewItem &&
          this.itemData.details && this.itemData.details[0] && this.itemData.details[0].eventCostId === null) {
          this.itemData.details[0].eventCostId = selectedEvent.costs[0].id
        }
        this.maxPartySize = selectedEvent.maxPartySizeStaff
        this.loadSeatingTimes()
        this.loadQuestions()
      }
      this.clearPathErrors(this.jsonPath, 'eventId')
    },
    selectedSeatingTime (val, oldVal) {
      // Seating time changed
      if (val !== oldVal && val && !val.disabled && !val.blockerReason &&
          JSON.stringify(val) !== JSON.stringify(oldVal)) {
        // Seating time has changed
        console.log('Seating time set', val, oldVal)
        this.maxPartySize = val.maxPartySizeStaff
        this.$nextTick(() => {
          // Get/update placeholder
          this.getPlaceHolder()
          // Load questions
          this.loadQuestions()
        })
      } else if (!val) {
        // No seating time selected.
        // TODO:  Clear placeholder?
        console.log('Seating time cleared')
      }
      this.clearPathErrors(this.jsonPath, 'time')
    },
    eventToLocations: {
      handler (val) {
        if (this.availLocations.length === 1 && !this.itemData.locationId) {
          this.itemData.locationId = this.availLocations[0].id
        }
      },
      deep: true
    },
    maxPartySize () {
      this.generateDetailWarnings()
    },
    mealPeriods (mealPeriods) {
      for (let location of this.locations) {
        // this.locationLookupMap[location.id] = location
        if (!mealPeriods.find(mealPeriod => mealPeriod.locationId === location.id)) location.disabled = true
      }
    },
    itemDetails (details, oldDetails) {
      // TODO: Try to move this out of the itemDetails watcher
      this.generateDetailWarnings()
      this.generateAnswers()
    },
    partySize (val, oldVal) {
      if (this.selectedSeatingTime && this.itemData.details.length !== oldVal) {
        // Party size has changed from held party size.
        this.getPlaceHolder()
      }
    },
    // selectedEventsCostsFilter (val) {
    //   // Clear priceCategoryId filter if selected event filter doesn't have it
    //   if (!val || !val.find(c => c.id === this.searchFilter.eventCostId)) {
    //     this.searchFilter.eventCostId = null
    //   }
    // },
    // selectedEventsFilter (val) {
    //   if (val && val.length) this.searchFilter.mealPeriodId = null
    // },
    // selectedMealPeriodFilter (val) {
    //   if (val) this.searchFilter.eventId = null
    // },
    /*
    reservationContextMenu: {
      handler () {
        console.log('Context Menu Changed', this.reservationContextMenu)
      },
      deep: true
    },
    */
    // searchFilter: {
    //   handler () {
    //     console.log('Search Filter Changed', this.searchFilter)
    //     // Save list filter for this route.  It will be used again when we return
    //     setGlobalValue(this.getSavedSearchFilterId(), 'listFilter', this.searchFilter)
    //     this.loadList()
    //   },
    //   deep: true
    // },
    selectedItemId () {
      console.log('Reservation Item changed')
    }
  }
}
